import React from 'react';

import AuthorUnit from '@components/FeedItems/AuthorUnit';
import type { ForumPost } from '@interfaces/homepage';
import { forum_post_path } from '@routes';

interface TrendingPostCardProps {
  post: ForumPost;
  onClick: (text: string, id?: number) => void;
}

const TrendingPostCard = ({ post, onClick }: TrendingPostCardProps) => {
  return (
    <article className="flex flex-col justify-between gap-24 border-0 border-r border-solid border-grayscale-gray pr-24 last-of-type:border-r-0 last-of-type:pr-0">
      <a
        className="mt-16 block font-suisse-neue text-body-md font-normal text-black no-underline transition-colors duration-150 hover:text-primary-magenta"
        href={forum_post_path(post.id)}
        onClickCapture={() => onClick(post.title, post.id)}
      >
        {post.title}
      </a>
      <AuthorUnit author={{ ...post.author, profileEnabled: true }} isRightRail />
    </article>
  );
};

export default TrendingPostCard;
